import { render, staticRenderFns } from "./OrdersAmazon.vue?vue&type=template&id=97a7ed8a"
import script from "./OrdersAmazon.vue?vue&type=script&lang=js"
export * from "./OrdersAmazon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports